import { api, registry } from './api';
import CacheStorage from './CacheStorage';
import { v4 as uuid } from 'uuid';

const baseURL = `${process.env.REACT_APP_API_URL}api`;

const cacheStorage = new CacheStorage();

const getCachedDivisions = async () => {
  const url = `${baseURL}/me/divisions`;
  const items = await cacheStorage.getFromCache(url);
  return items || undefined;
};
const getCachedSubDivision = async () => {
  const url = `${baseURL}/division/subdivision`;
  const items = await cacheStorage.getFromCache(url);
  return items || undefined;
};
const getCacheBackPaged = async () => {
  const url = `${baseURL}/Reports/reportsummaries/filter`;
  const items = await cacheStorage.getFromCache(url);
  return items || undefined;
};
const getCachedActivity = async () => {
  const url = `${baseURL}/activity`;
  const items = await cacheStorage.getFromCache(url);
  return items || undefined;
};
const getCachedCompanies = async () => {
  const url = `${baseURL}/company`;
  const items = await cacheStorage.getFromCache(url);
  return items || undefined;
};

const getCachedProjects = async () => {
  const url = `${baseURL}/project`;
  const items = await cacheStorage.getFromCache(url);
  return items || undefined;
};

const getCachedWorkSites = async () => {
  const url = `${baseURL}/WorkSite?page=0`;
  const items = await cacheStorage.getFromCache(url);
  return items || undefined;
};

const getCachedCountry = async () => {
  const url = `${baseURL}/country`;
  const items = await cacheStorage.getFromCache(url);
  return items || undefined;
};

const getCachedStatus = async () => {
  const url = `${baseURL}/registry/status`;
  const items = await cacheStorage.getFromCache(url);
  return items || undefined;
};
const getCachedSubcontractors = async () => {
  const url = `${baseURL}/reports/subcontractors`;
  const items = await cacheStorage.getFromCache(url);
  return items || undefined;
};
const getCachedEnvironmentSchema = async (id) => {
  const url = `${baseURL}/reports/environmentschema/${id}`;
  const items = await cacheStorage.getFromCache(url);
  return items || undefined;
};
const getCachedReportEnvironment = async (id) => {
  const url = `${baseURL}/reports/environment/${id}`;
  const items = await cacheStorage.getFromCache(url);
  return items || undefined;
};
const getCachedReportSafety = async (id) => {
  const url = `${baseURL}/reports/safety/${id}`;
  const items = await cacheStorage.getFromCache(url);
  return items || undefined;
};
const getCachedReportAssetIntegrity = async (id) => {
  const url = `${baseURL}/reports/assetIntegrity/${id}`;
  const items = await cacheStorage.getFromCache(url);
  return items || undefined;
};
const geCachedLeasedAssetReportData = async (idReport) => {
  const url = `${baseURL}/reports/environment/${idReport}/leasedasset`;
  const items = await cacheStorage.getFromCache(url);
  return items || undefined;
};
const ReportRepository = {
  getDivisions: async () =>
    (await getCachedDivisions()) || (await api.getAll(`${baseURL}/me/divisions`)).data,
  getSubDivision: async () =>
    (await getCachedSubDivision()) || (await api.getAll(`${baseURL}/division/subdivision`)).data,
  getActivity: async () =>
    (await getCachedActivity()) || (await api.getAll(`${baseURL}/activity`)).data,
  getCompanies: async () =>
    (await getCachedCompanies()) || (await api.getAll(`${baseURL}/company`)).data,
  getProjects: async (company) => {
    const projects =
      (await getCachedProjects()) || (await api.getAll(`${baseURL}/me/project`)).data;
    if (company) return projects.filter((w) => w.idCompany === company);
    return projects;
  },
  getBackPaged: async () => {
    return await getCacheBackPaged();
  },
  getCountry: async () =>
    (await getCachedCountry()) || (await api.getAll(`${baseURL}/country`)).data,
  getStatus: async () =>
    (await getCachedStatus()) || (await api.getAll(`${baseURL}/registry/status`)).data,
  getWorkSites: async () =>
    (await getCachedWorkSites()) ||
    (await api.getWithParam('/WorkSite', { params: { page: 0 } })).data,
  getSubcontractors: async () => (await api.getAll(`${baseURL}/reports/subcontractors`)).data ||
    (await getCachedSubcontractors()),
  getListLeasedAssetReportData : async (id) => (await api.getAll(`${baseURL}/reports/environment/${id}/listleasedassets`)).data,
  getLeasedAssetById : async (idRport, id) => (await api.getAll(`${baseURL}/reports/environment/${idRport}/leasedasset/${id}`)).data,
  getEnvironmentSchema: async (id) =>
    (await getCachedEnvironmentSchema()) ||
    (await api.getAll(`${baseURL}/reports/environmentschema/${id}`)).data,
  getSafetyComputedField: async (id, idSubContractor) => {
    try {
      return (
        await api.getAll(
          `${baseURL}/reports/safety/computedFields/?id=${id}&idSubContractor=${idSubContractor}`
        )
      ).data;
    } catch {
      const computedField = {
        id: uuid(),
        isSaipem: false,
        idSubContractor: null,
        subContractor: null,
        averageManpower: null,
        workedManhours: null,
        fatalAccidents: 0,
        lostTimeInjuries: 0,
        workRestrictedCases: 0,
        medicalTreatments: 0,
        firstAidCases: 0,
        nearMissHS: 0,
        nearMissENV: 0,
        daysLost: 0,
        restrictedWorkDays: 0,
        commutingInjuries: 0,
        roadTrafficAccidents: 0,
        kmDriven: null,
        hseTrainingHours: null,
        jobSafetyAnalysis: null,
        toolBoxTalks: null,
        seniorManagementHSEVisits: null,
        hseInspections: null,
        hseMeetings: null,
        drillHS: null,
        drillENV: null,
        drillHSPlanned: null,
        drillENVPlanned: null,
        hazardObservationCards: 0,
      };
      return computedField;
    }
  },
  getReportEnvironment: async (id) =>
    (await api.getAll(`${baseURL}/reports/environment/${id}`)).data,
  getReportSafety: async (id) => (await api.getAll(`${baseURL}/reports/safety/${id}`)).data,
  getReportAssetIntegrity: async (id) =>
    (await api.getAll(`${baseURL}/reports/assetIntegrity/${id}`)).data,
  updateCachedReportList: async (data) => {
    const url = `${baseURL}/reports/reportsummaries/${data.id}`;
    await cacheStorage.updateCache(data, url);
  },
  updateCachedEnvironment: async (id, data) => {
    const url = `${baseURL}/reports/environment/${id}`;
    const dataCached = await getCachedReportEnvironment(id);
    if(dataCached){
      dataCached.oilSpillNumberEnvSampling = data.oilSpillNumberEnvSampling;
      dataCached.oilSpillRecoveredVolum = data.oilSpillRecoveredVolum;
      dataCached.oilSpillExistentOilResponse = data.oilSpillExistentOilResponse;
      dataCached.chemicalSpillNumberEnvSampling = data.chemicalSpillNumberEnvSampling;
      dataCached.chemicalSpillRecoveredVolum = data.chemicalSpillRecoveredVolum;
      dataCached.bottleWater = data.bottleWater;
      dataCached.waterSourceReportData = data.waterSourceReportData;
      dataCached.waterDischargedReportData = data.waterDischargedReportData;
      dataCached.waterReusedReportData = data.waterDischargedReportData;
      dataCached.wasteHazReportData = data.wasteHazReportData;
      dataCached.wasteNonHazReportData = data.wasteNonHazReportData;
      dataCached.energySourceReportData = data.energySourceReportData;
      dataCached.oilSpillReportData = data.oilSpillReportData;
      dataCached.chemicalSpillReportData = data.chemicalSpillReportData;
      dataCached.wasteMonetizationReportData = data.wasteMonetizationReportData;
  
      dataCached.waterSourceNotes = data.waterSourceNotes;
      dataCached.waterDischargedReusedNotes = data.waterDischargedReusedNotes;
      dataCached.waterHazNotes = data.waterHazNotes;
      dataCached.waterNonHazNotes = data.waterNonHazNotes;
      dataCached.energySourceNotes = data.energySourceNotes;
      dataCached.oilSpillNotes = data.oilSpillNotes;
      dataCached.chemicalSpillNotes = data.chemicalSpillNotes;
      dataCached.wasteMonetizationNotes = data.wasteMonetizationNotes;
      await cacheStorage.updateCache(dataCached, url)
    }
;
  },
  updateCachedSafety: async (id, data) => {
    const url = `${baseURL}/reports/safety/${id}`;
    const dataCached = await getCachedReportSafety(id);
    //RITM0959400 - Undefined Error Message Fix
    if(dataCached){
      dataCached.safetyData = data;
      await cacheStorage.updateCache(dataCached, url);
    }
    //End
  },
  updateCachedAssetIntegrity: async (id, data) => {
    const url = `${baseURL}/reports/assetIntegrity/${id}`;
    const dataCached = await getCachedReportAssetIntegrity(id);
    dataCached.assetIntegrity = data;
    await cacheStorage.updateCache(dataCached, url);
  },
  updateReportDetail: async (data) => {
    let url;
    switch (data.discipline) {
      case 'Safety':
        url = `${baseURL}/reports/safety/${data.id}`;
        data.safetyData = [];
        // data.compiledBy= "Francesco Pollice"
        break;
      case 'Environment':
        url = `${baseURL}/reports/environment/${data.id}`;
        data.oilSpillNumberEnvSampling = 0;
        data.oilSpillRecoveredVolum = 0;
        data.oilSpillExistentOilResponse = false;
        data.chemicalSpillNumberEnvSampling = 0;
        data.chemicalSpillRecoveredVolum = 0;
        data.bottleWater = 0;
        // data.idReportEnvironment: "f77593ab-db71-4b90-4993-08d7e05580f1"
        data.waterSourceReportData = [];
        data.waterDischargedReportData = [];
        data.waterReusedReportData = [];
        data.wasteHazReportData = [];
        data.wasteNonHazReportData = [];
        data.energySourceReportData = [];
        data.leasedAssetReportData = [];
        data.oilSpillReportData = [];
        data.chemicalSpillReportData = [];
        data.wasteMonetizationReportData = [];
        break;
      default:
        url = `${baseURL}/reports/assetIntegrity/${data.id}`;
        data.assetIntegrity = {
          id: uuid(),
          vsc: 0,
          scEq: 0,
          scc: 0,
          scp: 0,
          scEqPS: 0,
          sccps: 0,
          scpps: 0,
          scEqPSES: 0,
          sccpses: 0,
          vscActionsOverdue: 0,
          vscActionsRaised: 0,
          closedMoC: 0,
          totalMoC: 0,
          overdueAIAudits: 0,
          plannedAIAudits: 0,
          overdueWOSafetyCriticalEquipment: 0,
          plannedWOSafetyCriticalEquipment: 0,
          scEqFailures: 0,
          sccCoveredByMT: 0,
          missingOrExpiredMT: 0,
          totalExpectedMT: 0,
          sccConveredByCompetence: 0,
          sctCoveredBySCPOrTFC: 0,
          totalSCT: 0,
          updatedEmergencyPlan: 0,
        };
        break;
    }

    await cacheStorage.updateCache(data, url);
  },
  updateReportFilter: async (data) => {
    const url = `${baseURL}/Reports/reportsummaries/filter`;
    await cacheStorage.updateCache(data, url);
  },
  updateReport: async (data) => {
    const url = `${baseURL}/Reports/reportsummaries`;
    await cacheStorage.updateCache(data, url);
  },
  updateLeasedAssetReportData: async (idReport, data) => (await api.put(`${baseURL}/reports/environment/${idReport}/leasedasset`, data)),
  updateCachedLeasedAssetReportData: async (idReport, data) => {
    const url = `${baseURL}/reports/environment/${idReport}/leasedasset`;
    const dataCached = await geCachedLeasedAssetReportData(idReport);
    dataCached.leasedAssetReportData = data;
    await cacheStorage.updateCache(dataCached, url);
  },
  createLeasedAssetReportData: async (idReport, data) => (await api.post(`${baseURL}/reports/environment/${idReport}/createleasedasset`, data)),
  preFetch: async () => {
    await api.getAll(`${baseURL}/Reports/reportsummaries?page=1&pageSize=10`);
    await api.getAll(`${baseURL}/Reports/reportsummaries?page=2&pageSize=10`);
    await api.getAll(`${baseURL}/Reports/reportsummaries?page=3&pageSize=10`);
    await api.getWithParam('/WorkSite', { params: { page: 0 } });
    await api.getAll(`${baseURL}/reports/environmentschema`);
    await api.getAll(`${baseURL}/reports/subcontractors`);
    await api.getAll('/me/worksitesproject');
    await registry.getAll('infooriginator');
  },
  deleteLeasedAssetReportData : async (idReport, id) => (await api.delete(`${baseURL}/reports/${idReport}/environment/leasedassetreportdata/`, id)),
};
export default ReportRepository;
